import { render, staticRenderFns } from "./price_maintain.vue?vue&type=template&id=bc6e87ee"
import script from "./price_maintain.vue?vue&type=script&lang=js"
export * from "./price_maintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6e87ee')) {
      api.createRecord('bc6e87ee', component.options)
    } else {
      api.reload('bc6e87ee', component.options)
    }
    module.hot.accept("./price_maintain.vue?vue&type=template&id=bc6e87ee", function () {
      api.rerender('bc6e87ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/price_maintain/price_maintain.vue"
export default component.exports